<nb-layout
  class="{{ !!business?.id ? 'business-' + business?.slug : 'business-main' }}"
>
  <nb-layout-column style="margin: 2rem 1rem">
    <nb-auth-block>
      <router-outlet></router-outlet>
    </nb-auth-block>
  </nb-layout-column>
</nb-layout>
